<div class="space-y-6">
  <div hlmAlert variant="info">
    <ng-icon name="lucideQrCode" />
    <p hlmAlertTitle>Generiere und drucke QR-Codes für deinen Gutschein-Shop</p>
    <p hlmAlertDescription>
      Der QR-Code führt Kunden direkt zu
      @if (suburl) {
        <a
          [href]="storefrontUrl"
          target="_blank"
          rel="noopener"
          class="text-foreground inline-flex max-w-full items-center gap-1 font-medium break-all underline underline-offset-4">
          {{ getStorefrontDisplayUrl() }}
          <ng-icon name="lucideExternalLink" class="shrink-0 text-[length:--spacing(3.5)]" />
        </a>
      } @else {
        deinem Gutschein-Shop
      }
      — platziere sie gut sichtbar in deinem Geschäft.
    </p>
  </div>

  @if (companyName && storefrontUrl) {
    <app-qr-code-card
      [storeName]="companyName"
      [storefrontUrl]="storefrontUrl"
      [showPrintButton]="true" />
  }
</div>
